import React,{useEffect,useState} from 'react';
import { Grid,Box, Typography, Button,Tooltip,Modal,Badge } from '@mui/material';
import {IconButton} from '@mui/material';
import {ReactComponent as StaffVector} from '../../StaticData/Vectors/staffVector.svg';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useDeletePerson,useDeleteInvitedPerson} from '../../Hooks';
import { useSelector } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import MessageIcon from '@mui/icons-material/Telegram';
import CloseIcon from "@mui/icons-material/Close";
import Chat from '../../../TenantDash/LComponents/AllTenantDash/ChatModal';
interface Message {
  id: number;
  text: string;
  sender: "user" | "other";
  mediaUrl?: string;
  mediaType?: "image" | "audio";
  timestamp: string;
  isRead: boolean;
}
export const StaffCart = (props:any) => {
    const userId=useSelector((state:any)=>state.loign.userInfo.userId);
    const tenantId:string|null=useSelector((state:any)=>state.meetings.profileTenantId);
    const userPhoneNumber=useSelector((state:any)=>state.loign.userPhoneNumber);
    const [isOpen1, setIsOpen1] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const{mutate:deletePerson,data:deletePersonData,isSuccess:deletePerSuccess}=useDeletePerson();
    const{mutate:deleteInvitedPerson,data:deleteInvitedData,isSuccess}=useDeleteInvitedPerson();
    // let{setPersonId}=props
    //     setShowToastMessage={setShowToastMessage}
    // setAddStaffState={setUserAsyncOpState}
    let{item,personPicture,setPersonId,setShowEditModal,setPersonIdFDelete,actived,setDeleteState,setShowToastMessage}=props;
    // console.log(item)
    let{name,jobTypeName,activated,id,phoneNumber,pictureBase64String}=item;
    const[imgSrc,setImgSrc]=useState<any>(null);


const initialEditPerson=(perId:string|null)=>{
setShowEditModal(true)
setPersonId(id)
}



const initialDelete=(id:any)=>{
    // activated,id
   if (activated) {
    let deletePersonBody={
        DeletedPersonId:id,
        UserId:userId,
        TenantId:tenantId
    }
    // console.log(deletePersonBody)
    deletePerson(deletePersonBody);
    handleClos();
   }
   else{
    let invitedPersonBody={
        phoneNumber:phoneNumber,
        lastModifiedById:userId,
        userId:userId,
        tenantId:tenantId

    }
    // console.log(invitedPersonBody)
    deleteInvitedPerson(invitedPersonBody);
    handleClos();
   }

    // console.log(item)

}

useEffect(() => {
  
    if (deleteInvitedData) {
        setShowToastMessage(true)
        setDeleteState(deleteInvitedData?.data)
    }


}, [deleteInvitedData,isSuccess])

useEffect(() => {
  
    if (deletePersonData) {
        setShowToastMessage(true)
        setDeleteState(deletePersonData?.data)
    }


}, [isSuccess,deletePersonData])

useEffect(() => {
  if (item) {
    setImgSrc(pictureBase64String)
  }
    }, [item])

    const [open, setOpen] = React.useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // برای بررسی سایز صفحه
    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClos = () => {
      setOpen(false);
    };

  return (
    <Box
    width={isMobile ? '315px' : '390px'}  // عرض در موبایل کوچکتر می‌شود
    height={isMobile ? '105px' : '105px'} // ارتفاع در موبایل کوچکتر می‌شود
    marginRight={1}
    borderRadius={3}
    boxShadow={2}
  >        <Grid container px={2} rowGap={1} >
{/*             
        <Grid item xs={2}   >
    <Box  display={'flex'} 
    flexDirection={'column'} 
    justifyContent={'center'} 
    pt={2}
    
    >
        <Box 
        py={1}
    textAlign={'center'}
    display={'flex'}
    alignItems={'center'}
    flexDirection={'column'}
    justifyContent={'cenetr'}
    > */}
          {/* <img src={imgSrc} width={'50px'} 
        style={{borderRadius:'50%',boxShadow:'20px'}}
         /> */}
          {/* {
                <img src={
                  personPicture !== null && personPicture !== undefined &&
                  personPicture.filter((x:any)=>x.personId === id)[0] !== null &&
                  personPicture.filter((x:any)=>x.personId === id)[0]!== undefined
                  ?
                  personPicture.filter((x:any)=>x.personId === id)[0].pictureBase64String
                  :''
                } width={'60px'} style={{borderRadius:'50%'}} />
              }
        </Box>
    </Box>
         </Grid> */}
         <Grid item xs={2}>
  <Box
    display={"flex"}
    flexDirection={"column"}
    justifyContent={"center"}
    pt={2}
  >
    <Box
      py={1}
      textAlign={"center"}
      display={"flex"}
      alignItems={"center"}
      flexDirection={"column"}
      justifyContent={"center"}
    >
      {
        <img
          src={
            personPicture !== null &&
            personPicture !== undefined &&
            personPicture.filter((x: any) => x.personId === id)[0] !== null &&
            personPicture.filter((x: any) => x.personId === id)[0] !== undefined
              ? personPicture.filter((x: any) => x.personId === id)[0]
                  .pictureBase64String
              : ""
          }
          // alt="Person"
          style={{
            borderRadius: "50%",
            width: "60px", // عرض ثابت
            height: "60px", // ارتفاع ثابت
            objectFit: "contain", // نمایش کامل تصویر با تناسب
          }}
        />
      }
    </Box>
  </Box>
</Grid>

         <Grid item xs={10} px={1} >
         <Grid container   >
        <Grid item xs={7}  height={'70px'} >
        <Box  p={1} pt={2} minHeight={'20px'}  >
            <Typography color={'#001733'} fontSize={'14px'} fontWeight={900}  >
            {
            name
            }
            </Typography>
        </Box>
        <Box minHeight={'8px'}  p={1} display={'flex'} alignItems={'end'} justifyContent={'start'}  >
          {
             jobTypeName.length > 20? <Tooltip sx={{ fontSize: '0.75rem !important' }} title={ jobTypeName}>
              <Typography sx={{ fontSize: '12px !important', color:'#001733', fontWeight:'500' ,cursor:'pointer',textAlign:'left' }}   >{ jobTypeName.slice(0, 20)}</Typography>
            </Tooltip> : <Typography sx={{ fontSize: '12px !important',color:'#001733', fontWeight:'500' ,cursor:'pointer',textAlign:'left' }}    >
              {
               jobTypeName
              }
            </Typography>
          }
        </Box>
        </Grid>
        <Grid item xs={5} height={'35px'} >
        <Box width={'90px'} textAlign={'end'} px={1} >
      <Box display={'flex'} flexDirection={'row'}>
      {/* <div>
      <Tooltip title="پیام خصوصی">
        <Badge
          badgeContent={unreadCount}
          color="error"
          invisible={unreadCount === 0}
          sx={{
            ".MuiBadge-badge": {
              top: "5px",
              right: "40px",
              transform: "translate(50%, -50%)",
              width: 20,
              height: 20,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "0.75rem",
            },
          }}
        >
          <IconButton onClick={handleOpen} color="primary" size="large" sx={{ position: "relative" }}>
            <MessageIcon />
          </IconButton>
        </Badge>
      </Tooltip>

      <Modal
        open={isOpen}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: "8px",
            padding: 4,
            width: "90%",
            maxWidth: "900px",
            position: "relative",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              padding: 1,
              top: "17px",
              right: "-2px",
              transform: "translateY(-50%)",
            }}
          >
            <HighlightOffIcon />
          </IconButton>
              <Chat
      messages={messages}
      onSendMessage={handleSendMessage}
      onMarkAsRead={markAsRead}
      onEditMessage={handleEditMessage}
      onDeleteMessage={handleDeleteMessage}
    />
        </Box>
      </Modal>
    </div> */}


        <Box>
          
      <Tooltip  title="ویرایش">
      <IconButton onClick={()=>{
            initialEditPerson(id)
        }}   >
        <EditIcon color='primary'   />
       </IconButton>
       </Tooltip>
       </Box>
       <Box>
       
       <Tooltip  title="حذف">
        <IconButton  onClick={handleClickOpen}>
        <DeleteIcon color='error'   />
       </IconButton>
       </Tooltip>
       <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClos}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" fontWeight={600} fontSize={'17px'}>
          {"آیا از حذف پرسنل اطمینان دارید؟"}
        </DialogTitle>
        <DialogActions >
          <Button autoFocus onClick={handleClos} >
            <Typography  color={'red'}> انصراف</Typography> 
          </Button>
          <Button autoFocus onClick={()=>{ initialDelete(id)}} >
            <Typography  color={'#00387C'} > تایید</Typography> 
          </Button>
        </DialogActions>
      </Dialog>
      </Box>
     
      </Box>
      <Box pt={2}  height={'60px'} marginRight={1} display={'flex'} alignItems={'center'} justifyContent={'end'} >
        <Box   height={'25px'} width={'85px'}
                bgcolor={activated?'#D5f7D4':'#bfd3f5'}  borderRadius={2} display={'flex'} alignItems={'center'} justifyContent={'center'}>
          <Typography fontSize={'0.7rem'} fontWeight={activated?900:400} color={activated?'green':'#3a82fc'}  >
              {
                  activated?'فعال':'دعوت شده'

              }</Typography>
          </Box>
        </Box>
        
      </Box>
        </Grid>
        </Grid>
        </Grid>   
        </Grid>
    </Box>
  )
}
